'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var allowedEncodings = exports.allowedEncodings = [false, 'json', 'text', 'form-data', 'x-www-form-urlencoded'];

var defaults = exports.defaults = {
  bracketStyleArrays: false,
  queryStringifier: function queryStringifier(body) {
    var urlSearchParams = new URLSearchParams();
    this._encodeForm(body, urlSearchParams, true);
    return '?' + urlSearchParams.toString();
  },

  encoding: 'json',
  post: {
    headers: {
      Accept: 'application/json'
    }
  },
  put: {
    headers: {
      Accept: 'application/json'
    }
  },
  patch: {
    headers: {
      Accept: 'application/json'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@synapsestudios/fetch-client/lib/defaults.js
// module id = 697
// module chunks = 0